import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import type { Provider } from '@/features/providers/types';

export function useProvider(providerId?: number) {
  return useQuery({
    queryKey: ['provider', providerId],
    queryFn: async () => {
      if (!providerId) throw new Error('Provider ID is required');
      
      const { data, error } = await supabase
        .from('providers')
        .select('*')
        .eq('id', providerId)
        .single();

      if (error) throw error;
      if (!data) throw new Error('Provider not found');

      return data as Provider;
    },
    enabled: !!providerId
  });
} 